import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_17b2255b: FaireBrandEntity = {
  token: "b_17b2255b",
  type: "brand",
  name: "Seda France Candles",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/970b1f262b4d303e6df2e01a6b9ece240994151266a3735bfd0e480fcbaf7e59/1557521327.jpg",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b2d767cbe438874637a6dea257050c481889c3f248893b42b282a7d7cb9a12e1/1556036950.png",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/970b1f262b4d303e6df2e01a6b9ece240994151266a3735bfd0e480fcbaf7e59/1557521327.jpg",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b2d767cbe438874637a6dea257050c481889c3f248893b42b282a7d7cb9a12e1/1556036950.png",
  location: "Austin\t, TX, USA",
  minimumOrderDollars: 500,
  rating: 4.7,
  reviewCount: 152,
  isInsider: true,
  description:
    "Since its inception in 2001, Austin, TX based Seda France has grown into a leading name in the home fragrance market, earning a reputation for exceptional scents and the signature packaging that has made their products renowned as the “gifts that need no wrapping paper.” \n\nAll customers must operate a brick and mortar retail space, orders are required to ship to a physical retail space and are subject to territory checks.\n\nFor quickest answers to any questions, please call our offices at [redacted-phone], M-F 8:30 a.m. - 4:30 p.m. CST.  You may also contact us at [redacted-email]. Thank you.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:19.966Z",
    importedBy: "entity-db-cli",
  },
};
